/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AfterInputs */

const en_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After`)
};

const fr_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après`)
};

const de_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach`)
};

const it_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo`)
};

const ru_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После`)
};

const es_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después`)
};

const zh_cn2_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后`)
};

const ja_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後`)
};

const hi_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाद`)
};

const pt_pt2_after = /** @type {(inputs: AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

/**
* | output |
* | --- |
* | "After" |
*
* @param {AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const after = /** @type {((inputs?: AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_after(inputs)
	if (locale === "de") return de_after(inputs)
	if (locale === "it") return it_after(inputs)
	if (locale === "ru") return ru_after(inputs)
	if (locale === "es") return es_after(inputs)
	if (locale === "zh-CN") return zh_cn2_after(inputs)
	if (locale === "ja") return ja_after(inputs)
	if (locale === "hi") return hi_after(inputs)
	if (locale === "pt-PT") return pt_pt2_after(inputs)
	return en_after(inputs)
});